import { isNodeActive } from '@ametista-ai/editor/utils';
import { useEditorState } from '@handlewithcare/react-prosemirror';
import { Button, Group, Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Icon } from '@/ui';
import { useToggleEditorNode } from './useToggleEditorNode';

export function ListBlockMenu() {
  const state = useEditorState();
  const [opened, { toggle, close }] = useDisclosure(false);

  const toggleUl = useToggleEditorNode('bullet_list');
  const isUlActive = isNodeActive(state.schema.nodes['bullet_list'], {}, state);

  const toggleOl = useToggleEditorNode('ordered_list');
  const isOlActive = isNodeActive(state.schema.nodes['ordered_list'], {}, state);

  return (
    <Menu opened={opened} onClose={close}>
      <Menu.Target>
        <Button size="xs" variant="default" onClick={toggle}>
          <Group gap="xs">
            {(isUlActive || !isOlActive) && <Icon name="list" />}
            {isOlActive && <Icon name="list" />}
            {opened ? <Icon name="chevronUp" /> : <Icon name="chevronDown" />}
          </Group>
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item onClick={toggleUl} rightSection={isUlActive && <Icon name="check" />}>
          <Icon name="list" />
        </Menu.Item>
        <Menu.Item onClick={toggleOl} rightSection={isOlActive && <Icon name="check" />}>
          <Icon name="listNumbers" />
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
